// extracted by mini-css-extract-plugin
module.exports = {"default":"idt-grid_default__1d29l","wrap":"idt-grid_wrap__28trw"};